import {BaseSyntheticEvent, FC, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {GET, POST, DELETE} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import {Loading} from '../../../../components/Loading/Loading'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import Swal from 'sweetalert2'
import uuid from 'react-uuid'
import useAuth from '../../../../hooks/useAuth'
import {PageTitle} from '../../../../../_metronic/layout/core'

// AlertTag type definition

type AlertTag = {
  id: number
  name: string
  img: string
}

const FoodAlertTagsPageContent: FC = () => {
  const navigate = useNavigate()
  const {verifyAdm} = useAuth()
  const isSupport = verifyAdm()
  const [loading, setLoading] = useState(true)
  const [tags, setTags] = useState<AlertTag[]>([])
  const [name, setName] = useState('')
  const [image, setImage] = useState<File | null>(null)

  const loadTags = async () => {
    try {
      const res = await GET('/food-alert-tag')
      if (res?.data) setTags(res.data)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!isSupport) {
      Swal.fire({
        icon: 'warning',
        title: 'Acesso restrito',
        text: 'Somente suporte Ninegrid pode cadastrar tags de alerta alimentar.',
      }).then(() => navigate('/dashboard'))
      return
    }

    loadTags()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSupport, navigate])

  const resolveImage = (img: string) => {
    if (img.startsWith('http')) return img
    return `${process.env.REACT_APP_AWS_S3_URL}/${img}`
  }

  const saveTag = async () => {
    if (!name.trim() || !image) {
      Swal.fire({icon: 'warning', title: 'Atenção', text: 'Preencha nome e imagem'})
      return
    }

    try {
      setLoading(true)
      const formData = new FormData()
      formData.append('file', image)
      formData.append('nameImage', `food-alert-tag-${uuid()}.png`)
      const uploadRes = await POST('/upload-images/upload-one', formData)

      if (!uploadRes.success) {
        Swal.fire({icon: 'error', title: 'Erro', text: 'Falha no upload da imagem'})
        return
      }

      await POST('/food-alert-tag', {
        name: name.trim(),
        img: uploadRes.image,
      })

      setName('')
      setImage(null)
      await loadTags()
      Swal.fire({icon: 'success', title: 'Sucesso', text: 'Tag criada com sucesso'})
    } catch (e) {
      Swal.fire({icon: 'error', title: 'Erro', text: 'Erro ao salvar tag'})
    } finally {
      setLoading(false)
    }
  }

  const removeTag = async (id: number) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Excluir tag?',
      text: 'Esta ação não pode ser desfeita.',
      showCancelButton: true,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
    })

    if (!result.isConfirmed) return

    try {
      setLoading(true)
      await DELETE(`/food-alert-tag/${id}`)
      await loadTags()
      Swal.fire({icon: 'success', title: 'Sucesso', text: 'Tag excluída com sucesso'})
    } catch (e) {
      Swal.fire({icon: 'error', title: 'Erro', text: 'Erro ao excluir tag'})
    } finally {
      setLoading(false)
    }
  }

  if (!isSupport) return null

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className='row g-5 gx-xxl-12'>
            <div className='d-flex justify-content-between flex-wrap'>
              <div style={{flex: 1}}>
                <div className='w-100 card'>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>Cadastrar tag</span>
                      <BreadCrumbs />
                      <span className='text-muted mt-1 fw-bold fs-7'>
                        Cadastre ícones de alerta alimentar para uso nas lojas.
                      </span>
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-lg-8'>
                        <Input
                          label='Nome'
                          inputAttr={{
                            type: 'text',
                            placeholder: 'Ex.: OVO, GLÚTEN, AMENDOIM',
                          }}
                          value={name}
                          change={(value: string) => setName(value)}
                        />
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-lg-8'>
                        <Input
                          inputAttr={{type: 'image'}}
                          label='Imagem da tag'
                          value={image}
                          change={(value: BaseSyntheticEvent | null) => {
                            if (!value || !value.target) {
                              setImage(null)
                              return
                            }
                            const file = value.target.files?.[0]
                            setImage(file || null)
                          }}
                        />
                        <div className='text-muted small mt-2'>
                          Selecione um arquivo do computador. Formatos: png, jpg, jpeg ou webp.
                        </div>
                      </div>
                    </div>

                    <div className='d-flex justify-content-end mt-5'>
                      <Button
                        text='Voltar'
                        color='info'
                        size='small'
                        click={() => navigate('/dashboard')}
                        btnClass='me-3'
                      />
                      <Button size='small' text='Salvar' color='primary' click={saveTag} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='row g-5 gx-xxl-12'>
            <div className='d-flex justify-content-between flex-wrap'>
              <div style={{flex: 1}}>
                <div className='w-100 card'>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>Tags cadastradas</span>
                      <span className='text-muted mt-1 fw-bold fs-7'>
                        {tags.length} tag(s) disponível(is) para as lojas
                      </span>
                    </h3>
                  </div>
                  <div className='card-body'>
                    {tags.length === 0 ? (
                      <div className='text-center text-muted py-10'>
                        Nenhuma tag cadastrada ainda.
                      </div>
                    ) : (
                      <div className='d-flex flex-wrap gap-6'>
                        {tags.map((tag) => (
                          <div
                            key={tag.id}
                            className='border border-gray-300 border-dashed rounded p-4 text-center'
                            style={{width: 120}}
                          >
                            <img
                              src={resolveImage(tag.img)}
                              alt={tag.name}
                              style={{
                                width: 56,
                                height: 56,
                                objectFit: 'contain',
                                borderRadius: '50%',
                                border: '2px solid #50cd89',
                                background: '#fff',
                              }}
                            />
                            <div className='fw-bold fs-7 mt-3 text-uppercase'>{tag.name}</div>
                            <Button
                              text='Excluir'
                              color='danger'
                              size='small'
                              click={() => removeTag(tag.id)}
                              btnClass='mt-3'
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

const FoodAlertTagsPage: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Tags de alerta alimentar', path: 'icon/food-alert-tags', isActive: true},
        ]}
      >
        Tags de alerta alimentar
      </PageTitle>
      <FoodAlertTagsPageContent />
    </>
  )
}

export {FoodAlertTagsPage}
